import { FC, useState } from "react";

import type { FibonacciSettings, LevelDisplay } from "../model";

import styles from "./styles/ToolSettingsModal.module.css";

const OPTIONS: { value: LevelDisplay; label: string }[] = [
  { value: "values", label: "Values" },
  { value: "percents", label: "Percents" },
];

interface Props {
  value: FibonacciSettings;
  onChange: (value: FibonacciSettings) => void;
}

export const FibonacciInputsTab: FC<Props> = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = OPTIONS.find((o) => o.value === value.levelDisplay)!;

  return (
    <div className={styles.tabContent}>
      <div className={styles.mainLineRow}>
        <span className={styles.mainLineLabel}>Levels</span>
        <div className={styles.customSelect}>
          <button
            className={styles.selectBtn}
            onClick={() => setIsOpen((v) => !v)}
          >
            {selected.label}
            <span className={styles.selectArrow}>▾</span>
          </button>
          {isOpen && (
            <div className={styles.selectDropdown}>
              {OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  className={`${styles.selectOption} ${opt.value === value.levelDisplay ? styles.selectOptionActive : ""}`}
                  onClick={() => {
                    onChange({ ...value, levelDisplay: opt.value });
                    setIsOpen(false);
                  }}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
